import $ from 'jquery';

class GoogleTrans {
  constructor() {
    this.translateLink = $('.c-main-nav__link[href*=googtrans]');

    if (!this.translateLink.length) {
      return;
    }

    this.triggerTranslation();
    this.setEnglishLink();
  }

  getCurrentLang() {
    this.cookies = document.cookie.split('; ');

    const cookies = {};
    let langs = null;

    for (let i = this.cookies.length - 1; i >= 0; i = -1) {
      const cookie = this.cookies[i].split('=');
      cookies[cookie[0]] = cookie[1]; // eslint-disable-line
    }

    if (cookies.googtrans === undefined) {
      if (window.location.hash.match(/#googtrans/) !== null) {
        const getLangs = window.location.hash.match(/#googtrans\((.*)\)/);

        if (getLangs.length > 1) {
          langs = getLangs[1].split('|');

          return langs.pop();
        }
      }
    } else {
      langs = cookies.googtrans.split('/');
    }

    return langs !== null && langs.length > 1 ? langs.pop() : null;
  }

  restore() {
    $(window).on('load', () => {
      this.translateBar = $('.goog-te-banner-frame').contents();
      const button = this.translateBar.find('button[id*=restore]');

      button.on('click', () => {
        window.location.hash = '';
        window.location.reload();
      });
    });
  }

  setEnglishLink() {
    this.isTranslated = this.getCurrentLang() !== null;
    // window.location.hash.match(/#googtrans/) !== null;

    if (this.getCurrentLang() === 'es') {
      $('body').addClass('c-body--lang-es');
    }

    if (this.isTranslated) {
      this.translateLink.text('English');
      $('body').addClass('c-body--istranslated');

      this.restore();
    }
  }

  triggerTranslation() {
    this.translateLink.on('click', e => {
      const self = $(e.currentTarget);
      e.preventDefault();

      if (this.isTranslated) {
        this.translateBar = $('.goog-te-banner-frame').contents();
        this.translateBar.find('button[id*=restore]').trigger('click');
        window.location.hash = '';
        window.location.reload();
      } else {
        window.location = self.attr('href');
        window.location.reload();
      }
    });
  }
}

export default GoogleTrans;



// WEBPACK FOOTER //
// ./src/scripts/modules/google-trans.js